import { Button } from "antd";
import { ReactElement } from "react";
import { TbArrowsExchange2 } from "react-icons/tb";
import { useAppStore } from "../../../store/store";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { MutationKeys, QueryKeys } from "../../../enums/react-query";
import { changeDistributorAccountPlan } from "../../../services/billing/billing.service";

export const UpdateAccountPlanModal = (): ReactElement => {
  const modalData = useAppStore((state) => state.modalData);
  const setModalIsOpen = useAppStore((state) => state.setModalIsOpen);
  const setModalData = useAppStore((state) => state.setModalData);

  const queryClient = useQueryClient();

  const { mutate: updateAccountPlanMutate, isPending: isAccountPlanUpdating } =
    useMutation({
      mutationKey: [MutationKeys.UPDATEDISTRIBUTORACCOUNTPLAN],
      mutationFn: () => changeDistributorAccountPlan(modalData[0]),
      onSuccess() {
        setModalIsOpen(false);
        setModalData([]);
        queryClient.invalidateQueries({
          queryKey: [QueryKeys.GETDISTRIBUTOR],
        });
        queryClient.invalidateQueries({
          queryKey: [QueryKeys.GETACCOUNTPLANACTIONS],
        });
      },
    });

  return (
    <div className="w-[370px] h-[280px] bg-white rounded-[8px] shadow ">
      <div className="flex flex-col w-full h-full items-center justify-between p-[30px] ">
        <div className="rounded-full bg-brand-yellow h-[59px] w-[59px] flex items-center justify-center ">
          <TbArrowsExchange2 className="text-[#FFA300] w-[33px] h-[33px]" />
        </div>
        <div className="flex flex-col items-center justify-center gap-[2px] text-center">
          <h5 className="Nunito font-[500] text-[20px] 2xl:text-[24px] text-[#1E1E1E] capitalize">
            {modalData[2]} account Plan?
          </h5>
          <p className="Nunito font-[300] text-[13px] 2xl:text-[15px] text-[#6B7280]">
            You're about to {modalData[2]} your account to the {modalData[1]}!
          </p>
        </div>
        <div className="flex items-center justify-center w-full gap-[10px] ">
          <Button
            type="primary"
            htmlType="button"
            className="Nunito w-full max-w-[95px] h-[30px] flex items-center justify-center bg-[#EFEFEF] hover:!bg-[#EFEFEF] !text-[#6B7280] hover:!text-[#6B7280] hover:opacity-[0.8] font-[500] text-[10px] 2xl:text-[12px] rounded-[8px]  "
            loading={false}
            onClick={() => {
              setModalIsOpen(false);
            }}
          >
            Cancel
          </Button>
          <Button
            type="primary"
            htmlType="button"
            className="Nunito w-full max-w-[95px] h-[30px] flex items-center justify-center bg-brand-darkYellow hover:!bg-brand-darkYellow !text-white hover:!text-white hover:opacity-[0.8] font-[500] text-[10px] 2xl:text-[12px] rounded-[8px]  "
            loading={isAccountPlanUpdating}
            onClick={() => {
              updateAccountPlanMutate();
            }}
          >
            Proceed
          </Button>
        </div>
      </div>
    </div>
  );
};
